import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(customParseFormat).extend(advancedFormat);

const dateFormat = (dateString, formatType = 'DD MMM, YY', parseToSeconds, isLastDayOfMonth) => {
	if (parseToSeconds && !isLastDayOfMonth) {
		const utcSeconds = dateString;
		const day = dayjs.unix(utcSeconds);
		dateString = day;
	}

	if (isLastDayOfMonth) {
		const day = dayjs.unix(dateString);
		dateString = day.endOf('month');
	}

	if (!dateString) return;

	dateString = dateString.toString().length === 10 ? dateString * 1000 : dateString;

	return dayjs(dateString).format(formatType);
};

export const formatDateTime = (timestamp = '', pattern) => {
	if (!timestamp) return '';
	const date = dayjs(timestamp);
	return date.format(pattern);
};

export const hourDifference = (value) => {
	if (!value) return 0;
	try {
		const currentDate = dayjs();
		const inputDate = dayjs.unix(value);
		const diff = inputDate.diff(currentDate, 'hour');
		return Math.abs(diff);
	} catch {
		return 0;
	}
};

export default dateFormat;
